import { Reducer } from 'redux';
import { ConfirmationDialogActionTypes } from '../actions/confirmationDialog.actions';
import { ConfirmationDialogStoreModel, initialConfirmationDialogStoreState } from '../store.model';

export const confirmationDialogReducer: Reducer<ConfirmationDialogStoreModel> = (
  state = initialConfirmationDialogStoreState,
  action
) => {
  switch (action.type) {
    case ConfirmationDialogActionTypes.OPEN:
      return { ...state, open: true };
    case ConfirmationDialogActionTypes.CLOSE:
      return { ...state, open: false, configuration: undefined };
    case ConfirmationDialogActionTypes.CONFIGURE:
      return { ...state, configuration: action.payload };
    case ConfirmationDialogActionTypes.SET_IS_WAITING:
      return { ...state, configuration: { ...state.configuration, isWaiting: action.payload } };
    default:
      return state;
  }
};
